import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-3">
            <i className="ri-hashtag"></i>
            <span>话题社区</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            漫迷社区正在热烈讨论的话题标签，加入韩漫、日漫、国漫的话题讨论
          </p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 max-w-4xl mx-auto justify-center">
          {topicsData.map((topic, idx) => (
            <a
              key={idx}
              href="#comments"
              className={`group inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-medium transition-all whitespace-nowrap ${
                topic.trending
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-600 border border-background-200/70 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <span>{topic.name}</span>
              {topic.trending && (
                <i className="ri-fire-line text-accent-300 text-xs"></i>
              )}
              <span className={`text-xs ${topic.trending ? 'text-background-200' : 'text-foreground-400'}`}>
                {topic.count.toLocaleString()}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}